// Function registry
import { setOrPcsByTitle } from './unit.js'

export const utilitiesRegistry = {
  'unit/setOrPcsByTitle': setOrPcsByTitle,
  // Add more utilities here as needed
}